module.exports = __webpack_public_path__ + "img/gelentjik.2dc3982f.png";